import { useAuth } from '~/store/auth'
import * as amplitude from '@amplitude/analytics-browser'
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser'
import { useGlobals } from '~/store/global'

export const init = () => {
  if (process.server) {
    return
  }

  const sessionReplayTracking = sessionReplayPlugin()
  amplitude.add(sessionReplayTracking)

  amplitude.init(useRuntimeConfig().public.amplitudeApiKey, {
    defaultTracking: true,
  })

  const globals = useGlobals()
  const userStore = useAuth()

  if (!globals.ati) {
    if (userStore.user?.ati !== null && userStore.user?.ati !== undefined) {
      globals.ati = userStore.user.ati
    } else {
      globals.ati = guid()
      if (userStore.user) {
        userStore.user.ati = globals.ati
      }
    }
  }

  setUserId(<string>globals.ati, userStore.user?.email)
  track('Session start')
}

export const track = (event: string, data?: unknown) => {
  amplitude.logEvent(event, <Record<string, unknown>>data)
}

export const setUserId = (ati: string, email?: string) => {
  const identify = new amplitude.Identify().set('user_id', ati)
  if (email) {
    identify.set('user_email', email)
  }

  amplitude.setUserId(ati)
  amplitude.identify(identify)
}
